import axios from "axios";
const token = localStorage.getItem("token");
const lang = localStorage.getItem("i18nextLng")
axios.defaults.headers.common["Accept"] = "application/json";
//http://192.168.1.143:8000/api/
//"https://api.barq-group.com/api/"
//https://barq.waitbuzz.info/api/

axios.defaults.baseURL =process.env.REACT_APP_BASE_URL
 axios.defaults.headers.common["Authorization"] = "Bearer " + `${token}`;
 axios.defaults.headers.common['Accept-Language'] =lang
// axios.defaults.withCredentials = true;

const instance = axios.create({  
  baseURL:process.env.REACT_APP_BASE_URL
,   
  // withCredentials: true,
  // withXSRFToken: true,
  headers: {
    Accept: "application/json",
  },  
}); 

instance.defaults.headers.common["Accept"] = "application/json";
export default instance;
